<app-thi-page-shell [lang]="landingLang">
<div class="register-page pt-20">
  <div class="register-shell">
    <div class="register-card">
      <div class="register-head">
        <h1>{{ 'Register.Createyouraccount' | translate }}</h1>
        <p>{{ 'Register.enter' | translate }}</p>
      </div>

      <form class="register-form" [formGroup]="RegisterForm" (ngSubmit)="submitRegisterForm(RegisterForm)">
        <div class="fields-grid">
          <div class="field-block">
            <label class="field-label">
              {{ curentLang === 'en' ? 'First Name' : (curentLang === 'ar' ? 'الاسم الأول' : 'שם פרטי') }}
            </label>
            <input
              class="form-control"
              type="text"
              maxlength="20"
              required=""
              [placeholder]="curentLang === 'en' ? 'First Name' : (curentLang === 'ar' ? 'الاسم الأول' : 'שם פרטי')"
              formControlName="first_name">
            <div *ngIf="RegisterForm.get('first_name')?.errors && RegisterForm.get('first_name')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('first_name')?.errors?.required">
                {{ curentLang === 'en' ? 'First name is required' : (curentLang === 'ar' ? 'الاسم الأول مطلوب' : 'שם פרטי הוא שדה חובה') }}
              </p>
              <p *ngIf="RegisterForm.get('first_name')?.errors?.maxlength">
                {{ curentLang === 'en' ? 'Maximum 20 characters' : (curentLang === 'ar' ? 'الحد الأقصى 20 حرفا' : 'מקסימום 20 תווים') }}
              </p>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">
              {{ curentLang === 'en' ? 'Last Name' : (curentLang === 'ar' ? 'اسم العائلة' : 'שם משפחה') }}
            </label>
            <input
              class="form-control"
              type="text"
              maxlength="20"
              required=""
              [placeholder]="curentLang === 'en' ? 'Last Name' : (curentLang === 'ar' ? 'اسم العائلة' : 'שם משפחה')"
              formControlName="last_name">
            <div *ngIf="RegisterForm.get('last_name')?.errors && RegisterForm.get('last_name')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('last_name')?.errors?.required">
                {{ curentLang === 'en' ? 'Last name is required' : (curentLang === 'ar' ? 'اسم العائلة مطلوب' : 'שם משפחה הוא שדה חובה') }}
              </p>
              <p *ngIf="RegisterForm.get('last_name')?.errors?.maxlength">
                {{ curentLang === 'en' ? 'Maximum 20 characters' : (curentLang === 'ar' ? 'الحد الأقصى 20 حرفا' : 'מקסימום 20 תווים') }}
              </p>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">{{ 'Register.phone' | translate }}</label>
            <div class="input-group phone-group">
              <span class="input-group-text">+972</span>
              <input class="form-control" type="text" inputmode="numeric" maxlength="10" required="" formControlName="phone_number">
            </div>
            <div *ngIf="RegisterForm.get('phone_number')?.errors && RegisterForm.get('phone_number')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('phone_number')?.errors?.required">{{ 'Register.phoneRequierd' | translate }}</p>
              <p *ngIf="RegisterForm.get('phone_number')?.errors?.pattern">
                {{ curentLang === 'en' ? 'Phone number must be exactly 10 digits' : (curentLang === 'ar' ? 'رقم الهاتف يجب أن يكون 10 أرقام بالضبط' : 'מספר הטלפון חייב להכיל בדיוק 10 ספרות') }}
              </p>
              <p *ngIf="RegisterForm.get('phone_number')?.errors?.invalidMobilePrefix">{{ RegisterForm.get('phone_number')?.errors?.invalidMobilePrefix.message }}</p>
              <p *ngIf="RegisterForm.get('phone_number')?.errors?.invalidPhoneNumber">{{ RegisterForm.get('phone_number')?.errors?.invalidPhoneNumber.message }}</p>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">{{ 'Register.merchantadress' | translate }}</label>
            <input
              class="form-control"
              type="text"
              required=""
              maxlength="400"
              [placeholder]="'Register.merchantadress' | translate"
              formControlName="merchant_address">
            <div *ngIf="RegisterForm.get('merchant_address')?.errors && RegisterForm.get('merchant_address')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('merchant_address')?.errors?.required">{{ 'Register.merchant_address' | translate }}</p>
              <p *ngIf="RegisterForm.get('merchant_name_he')?.errors?.maxlength">{{ 'Register.error3' | translate }}</p>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">{{ 'Register.id_number' | translate }}</label>
            <input
              class="form-control"
              type="text"
              inputmode="numeric"
              maxlength="9"
              required=""
              [placeholder]="'Register.id_number' | translate"
              formControlName="id_number">
            <div *ngIf="RegisterForm.get('id_number')?.errors && RegisterForm.get('id_number')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('id_number')?.errors?.required">{{ 'Register.id_numberreq' | translate }}</p>
              <p *ngIf="RegisterForm.get('id_number')?.errors?.pattern">
                {{ curentLang === 'en' ? 'ID number must be exactly 9 digits' : (curentLang === 'ar' ? 'رقم الهوية يجب أن يكون 9 أرقام بالضبط' : 'תעודת זהות חייבת להכיל בדיוק 9 ספרות') }}
              </p>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">{{ 'Register.password' | translate }}</label>
            <div class="password-wrap">
              <input
                class="form-control"
                [type]="show ? 'text' : 'password'"
                name="login[password]"
                required=""
                minlength="8"
                maxlength="20"
                placeholder="*********"
                formControlName="password">
              <button
                type="button"
                class="show-hide"
                [attr.aria-label]="show ? (curentLang === 'ar' ? 'إخفاء كلمة المرور' : (curentLang === 'he' ? 'הסתר סיסמה' : 'Hide password')) : (curentLang === 'ar' ? 'إظهار كلمة المرور' : (curentLang === 'he' ? 'הצג סיסמה' : 'Show password'))"
                [attr.title]="show ? (curentLang === 'ar' ? 'إخفاء كلمة المرور' : (curentLang === 'he' ? 'הסתר סיסמה' : 'Hide password')) : (curentLang === 'ar' ? 'إظهار كلمة المرور' : (curentLang === 'he' ? 'הצג סיסמה' : 'Show password'))"
                [ngClass]="{'rtl': curentLang === 'ar' || curentLang === 'he'}"
                (click)="showPassword()">
                <i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <div class="password-hint">
              {{ curentLang === 'en' ? 'Use 8-20 chars with upper/lowercase letters, numbers and symbols.' : (curentLang === 'ar' ? 'استخدم 8-20 حرفا مع أحرف كبيرة/صغيرة وأرقام ورموز.' : 'השתמש/י ב-8-20 תווים עם אותיות גדולות/קטנות, מספרים וסימנים.') }}
            </div>
            <div *ngIf="RegisterForm.get('password')?.errors && RegisterForm.get('password')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('password')?.errors?.required">{{ 'Login.passwordRequired' | translate }}</p>
              <p *ngIf="RegisterForm.get('password')?.errors?.minlength">{{ 'Login.passwordMinLength' | translate }}</p>
              <p *ngIf="RegisterForm.get('password')?.errors?.maxlength">{{ 'Login.passwordMaxLength' | translate }}</p>
              <p *ngIf="RegisterForm.get('password')?.errors?.uppercase">{{ 'Login.passwordUppercase' | translate }}</p>
              <p *ngIf="RegisterForm.get('password')?.errors?.specialChar">{{ 'Login.passwordSpecialChar' | translate }}</p>
            </div>
          </div>

          <div class="field-block">
            <label class="field-label">
              {{ curentLang === 'en' ? 'Confirm Password' : (curentLang === 'ar' ? 'تأكيد كلمة المرور' : 'אימות סיסמה') }}
            </label>
            <div class="password-wrap">
              <input
                class="form-control"
                [type]="showConfirm ? 'text' : 'password'"
                name="login[confirm_password]"
                required=""
                minlength="8"
                maxlength="20"
                [placeholder]="curentLang === 'en' ? 'Re-enter password' : (curentLang === 'ar' ? 'أعد إدخال كلمة المرور' : 'הקלד/י סיסמה שוב')"
                formControlName="confirm_password">
              <button
                type="button"
                class="show-hide"
                [attr.aria-label]="showConfirm ? (curentLang === 'ar' ? 'إخفاء كلمة المرور' : (curentLang === 'he' ? 'הסתר סיסמה' : 'Hide password')) : (curentLang === 'ar' ? 'إظهار كلمة المرور' : (curentLang === 'he' ? 'הצג סיסמה' : 'Show password'))"
                [attr.title]="showConfirm ? (curentLang === 'ar' ? 'إخفاء كلمة المرور' : (curentLang === 'he' ? 'הסתר סיסמה' : 'Hide password')) : (curentLang === 'ar' ? 'إظهار كلمة المرور' : (curentLang === 'he' ? 'הצג סיסמה' : 'Show password'))"
                [ngClass]="{'rtl': curentLang === 'ar' || curentLang === 'he'}"
                (click)="showConfirmPassword()">
                <i class="fa" [ngClass]="showConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <div *ngIf="RegisterForm.get('confirm_password')?.touched" class="error-block">
              <p *ngIf="RegisterForm.get('confirm_password')?.errors?.required">
                {{ curentLang === 'en' ? 'Confirm password is required' : (curentLang === 'ar' ? 'تأكيد كلمة المرور مطلوب' : 'אימות סיסמה הוא שדה חובה') }}
              </p>
              <p *ngIf="passwordMismatch">
                {{ curentLang === 'en' ? 'Passwords do not match' : (curentLang === 'ar' ? 'كلمتا المرور غير متطابقتين' : 'הסיסמאות אינן תואמות') }}
              </p>
            </div>
          </div>
        </div>

        <div class="pw-requirements" *ngIf="RegisterForm.get('password')?.value || RegisterForm.get('password')?.touched">
          <div class="pw-strength">
            <div class="pw-strength-row">
              <span>{{ curentLang === 'en' ? 'Password strength' : (curentLang === 'ar' ? 'قوة كلمة المرور' : 'חוזק הסיסמה') }}</span>
              <strong [ngClass]="passwordStrength.className">{{ passwordStrength.label }}</strong>
            </div>
            <div class="pw-strength-track">
              <span class="pw-strength-fill" [ngClass]="passwordStrength.className" [style.width.%]="passwordStrength.score * 20"></span>
            </div>
          </div>
          <div class="pw-req-title">
            {{ curentLang === 'en' ? 'Password requirements:' : (curentLang === 'ar' ? 'متطلبات كلمة المرور:' : 'דרישות סיסמה:') }}
          </div>
          <div class="pw-req-item" [class.met]="passwordChecks.uppercase">
            <i class="fa" [class.fa-check-circle]="passwordChecks.uppercase" [class.fa-circle-o]="!passwordChecks.uppercase"></i>
            {{ curentLang === 'en' ? 'At least one uppercase letter (A-Z)' : (curentLang === 'ar' ? 'على الأقل حرف واحد بأحرف كبيرة (A-Z)' : 'אות גדולה אחת לפחות (A-Z)') }}
          </div>
          <div class="pw-req-item" [class.met]="passwordChecks.lowercase">
            <i class="fa" [class.fa-check-circle]="passwordChecks.lowercase" [class.fa-circle-o]="!passwordChecks.lowercase"></i>
            {{ curentLang === 'en' ? 'At least one lowercase letter (a-z)' : (curentLang === 'ar' ? 'على الأقل حرف واحد بأحرف صغيرة (a-z)' : 'אות קטנה אחת לפחות (a-z)') }}
          </div>
          <div class="pw-req-item" [class.met]="passwordChecks.number">
            <i class="fa" [class.fa-check-circle]="passwordChecks.number" [class.fa-circle-o]="!passwordChecks.number"></i>
            {{ curentLang === 'en' ? 'At least one number (0-9)' : (curentLang === 'ar' ? 'على الأقل رقم واحد (0-9)' : 'ספרה אחת לפחות (0-9)') }}
          </div>
          <div class="pw-req-item" [class.met]="passwordChecks.specialChar">
            <i class="fa" [class.fa-check-circle]="passwordChecks.specialChar" [class.fa-circle-o]="!passwordChecks.specialChar"></i>
            {{ curentLang === 'en' ? 'At least one special character (!@#$%^&*)' : (curentLang === 'ar' ? 'على الأقل رمز خاص واحد (!@#$%^&*)' : 'תו מיוחד אחד לפחות (!@#$%^&*)') }}
          </div>
          <div class="pw-req-item" [class.met]="passwordChecks.minLength">
            <i class="fa" [class.fa-check-circle]="passwordChecks.minLength" [class.fa-circle-o]="!passwordChecks.minLength"></i>
            {{ curentLang === 'en' ? 'Minimum 8 characters' : (curentLang === 'ar' ? 'بحد الأدنى 8 أحرف' : 'לפחות 8 תווים') }}
          </div>
        </div>

        <div class="terms-checkbox-wrapper" [class.terms-checked]="RegisterForm.get('acceptTerms')?.value">
          <input type="checkbox" id="acceptTerms" formControlName="acceptTerms" class="terms-checkbox">
          <label for="acceptTerms" class="terms-label">
            <span class="terms-text">
              {{ 'Register.AgreePrefix' | translate }}
              <a [routerLink]="['/terms-of-service']" href="/#/terms-of-service" class="terms-link" rel="noopener noreferrer">
                {{ 'Register.termsLink' | translate }}
              </a>
            </span>
          </label>
        </div>

        <button
          [disabled]="RegisterForm.invalid || RegisterForm.get('password')?.invalid || RegisterForm.get('acceptTerms')?.value !== true"
          class="submit-btn"
          type="submit">
          {{ 'Register.createacount' | translate }}
        </button>

        <p class="login-link-row">
          {{ 'Register.Already' | translate }}
          <a [routerLink]="'/login'">{{ 'Register.login' | translate }}</a>
        </p>
      </form>
    </div>
  </div>
</div>
</app-thi-page-shell>